/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>店员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" :model="formInline" class="user-search">
     <!-- <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varName" placeholder="输入公司名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="user_id" label="id" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="nick_name" label="昵称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="open_id1" label="公众号openID" width="300" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="union_id" label="unionID" width="300" show-overflow-tooltip>
      </el-table-column>

    <!--  <el-table-column prop="mch_role" label="角色" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.mch_role == 1">管理员</div>
          <div v-if="scope.row.mch_role == 4 ">员工</div>
        </template>
      </el-table-column> -->
      <el-table-column prop="state" label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.state == 0">启用</div>
          <div v-if="scope.row.state == 1 ">禁用</div>
        </template>
      </el-table-column>
      <!--  <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">预览</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button>
        </template>
      </el-table-column> -->
    </el-table>

  </div>
</template>

<script>
  import {
    getMerchantMemberList,
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        listData:[],
        entId: this.$route.query.id,

      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        let pro = {
            "mchId": this.entId
        }
        getMerchantMemberList(pro)
          .then(res => {
            this.loading = false
          if (res.code == 0) {
            this.listData = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },



    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/bus/clerk1.vue